import {
  Box,
  Text,
  Tabs,
  Spacer,
  Button,
  DropDown,
} from "@flexisaf/flexibull2";
import styled from "styled-components";
import Participants from "./tabs/Participants";
import BreadCrumbs from "../../components/breadcrumb";
import QuizathonInformation from "./tabs/QuizathonInformation";
import * as XLSX from "xlsx";
import useQuizathonParticipants from "../../hooks/quizathon/useQuizathonParticipants";
import { useParams } from "react-router-dom";

const QuizathonDetails = () => {
  const { id } = useParams();
  const { quizathonParticipants } = useQuizathonParticipants({
    quizathonId: id,
    fetchAll: false,
  });

  const excelData = quizathonParticipants?.items?.map((item) => {
    const { firstName, lastName, email, phoneNumber } = item.userInfo;
    const departmentName = item.department?.name || "";
    const schoolName = item.school?.name || "";
    return {
      firstName,
      lastName,
      departmentName,
      schoolName,
      email,
      phoneNumber,
    };
  });
  const exportToExcel = () => {
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(wb, ws, "sheet 1");
    XLSX.writeFile(wb, "participantlist.xlsx");
  };
  return (
    <Container>
      <BreadCrumbs
        links={[{ path: `/quizathon-list`, text: "Back" }]}
        last={"QuizathonList"}
      />
      <Spacer space={15} />
      <Text bold size="1.3rem">
        Quizathon 2024
      </Text>
      <Spacer space={15} />
      <Box style={{ display: "flex", justifyContent: "flex-end" }}>
        <DropDown
          label={
            <Button style={{ margin: "0 0.7rem" }}>
              Export Quizathon List
            </Button>
          }
          menuAlign="bottom right"
          trigger="click"
          className="dropdown"
          menuList={[
            {
              onClick: () => exportToExcel(),
              label: "Export Participants List",
              iconLeft: "saf-document",
            },
            {
              label: "Export  Result List",
              iconLeft: "saf-receipt-edit",
            },
          ]}
        />
      </Box>
      <Spacer space={20} />
      <Tabs responsive={false} bgColor="none" style={{ maxWidth: "100%" }}>
        <Box label="Participants List">
          <Participants />
        </Box>
        <Box label="Quizathon Information">
          <QuizathonInformation />
        </Box>
      </Tabs>
    </Container>
  );
};

const Container = styled(Box)``;
export default QuizathonDetails;
